import { render, staticRenderFns } from "./TableTrainer.vue?vue&type=template&id=5630b9f5&"
import script from "./TableTrainer.vue?vue&type=script&lang=js&"
export * from "./TableTrainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports